import { Container } from 'pixi.js';
import type { BlockerView } from '../../types';
import { AdBlockerLayout } from '../../../../../layouts/blockers/AdBlockerLayout';
import type { AdBlockerModel } from '../../models/blockers/AdBlockerModel';
import { playLayoutAnimation } from '../../../../libs/layouts/layoutAnimations/playLayoutAnimation';

export class AdBlockerView extends Container implements BlockerView {
  private readonly layout = new AdBlockerLayout();

  constructor(private readonly model: AdBlockerModel) {
    super();

    this.layout.root.props({
      parent: this,
    });

    void playLayoutAnimation(this.layout, 'Idle', true);
  }

  public getModel(): AdBlockerModel {
    return this.model;
  }

  public async animateRemoval(): Promise<void> {
    await playLayoutAnimation(this.layout, 'Unlock', false);

    this.destroy({ children: true });
  }
}
